var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-col",
        { staticClass: "pa-0" },
        [
          _c("span", [_vm._v("Тип Анкеты*")]),
          _c("v-select", {
            attrs: {
              outlined: "",
              dense: "",
              "item-text": "title",
              "item-value": "value",
              disabled: _vm.disabled,
              loading: _vm.loading,
              value: _vm.detailsEntityType,
              items: _vm.$options.detailsEntityTypes,
              "error-messages": _vm.detailsEntityTypesError,
            },
            on: {
              change: function ($event) {
                return _vm.$emit("change:details-entity-type", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pa-0" },
        [
          _c("span", [_vm._v("Анкета*")]),
          _c("v-autocomplete", {
            attrs: {
              "item-text": "name",
              "item-value": "id",
              outlined: "",
              dense: "",
              "hide-no-data": "",
              clearable: "",
              "auto-select-first": "",
              "hide-selected": false,
              items: _vm.details,
              loading: _vm.loading || _vm.isLoadingData,
              disabled: _vm.disabled,
              "error-messages": _vm.detailsEntityIdError,
              value: _vm.detailsEntityId,
            },
            on: {
              change: function ($event) {
                return _vm.$emit("change:details-entity-id", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function (data) {
                  return [
                    _c(
                      "router-link",
                      _vm._b(
                        { attrs: { to: _vm.redirectToDetail(data.item.id) } },
                        "router-link",
                        data.attrs,
                        false
                      ),
                      [_vm._v(_vm._s(data.item.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }